<template>
  <div class="flex justify-center">
    <div class="p-20 rounded shadow-2xl">
      <Input v-model="details.fullName" text label="Full Name" />
      <Input v-model="details.email" text label="Email Address" />
      <Input v-model="details.password" text label="Password" />
      <Input v-model="details.gender" text label="Gender" />
      <Input v-model="details.age" text label="Age" />
      <Input
        v-model="details.credentials"
        file
        :accept="['jpg', 'jpeg', 'png', 'pdf']"
        label="Credentials"
        @validated="uploading"
        validation-message="You can upload only pdf or image."
      />
      <div class="w-100 flex justify-end">
        <FadeTransition>
          <SaveButton v-show="unsavedChanges" @save="save" />
        </FadeTransition>
      </div>
    </div>
  </div>
</template>

<script>
import unsavedChanges from "@/mixins/unsavedChanges";
import SaveButton from "@/components/SaveButton";
import FadeTransition from "@/components/transitions/FadeTransition";

export default {
  name: "ProfileIndex",
  components: {
    SaveButton,
    FadeTransition
  },
  mixins: [unsavedChanges],
  props: {},
  computed: {},
  data() {
    return {
      fullName: "Nikandros Mavroudakis",
      details: {
        fullName: "Nikandros Mavroudakis",
        email: "m.nik1997@hotmail.com",
        password: "kodac6.1",
        gender: "Male",
        age: "23",
        credentials: null
      }
    };
  },
  methods: {
    uploading() {
      alert("uploading...");
    }
  },
  watch: {
    fullName: {
      handler(newValue) {
        console.log(newValue);
      }
    }
  },
  mounted() {
    this.track("details");
  }
};
</script>

<style></style>
